// @flow

import addOrderGroup from '../../../Services/addOrderGroup';

export default () => async (dispatch: Function) => dispatch(addOrderGroup())